module.exports = __webpack_public_path__ + "img/vi.c80b6da1.png";